import actionTypes from "./GTMWTWTR02ActionType";

/**
 * 作業時間管理取得
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: [],
};

/**
 * 作業時間管理を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const workingHours = (state = initialState, action) => {
    switch (action.type) {
        // 作業時間管理取得
        case actionTypes.GET_WORKING_HOURS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: [],
            });
        case actionTypes.GET_WORKING_HOURS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail,
            });
        case actionTypes.GET_WORKING_HOURS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: [],
            });
        case actionTypes.GET_WORKING_HOURS_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: [],
            });

        // 作業時間管理更新
        case actionTypes.UPDATE_WORKING_HOURS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: [],
            });
        case actionTypes.UPDATE_WORKING_HOURS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail,
            });
        case actionTypes.UPDATE_WORKING_HOURS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: [],
            });
        case actionTypes.UPDATE_WORKING_HOURS_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: [],
            });
        default:
            return state;
    }
};
